import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useWorkspaceAccess } from '@/composables/useWorkspaceAccess'

export function useWorkspaceStaffAccess(workspaceIdRef) {
  const authStore = useAuthStore()
  const workspaceAccess = useWorkspaceAccess()

  const canStaffManage = computed(() => {
    const globalRole = authStore.user?.role?.nome
    if (globalRole === 'ADMIN' || globalRole === 'SUPER_ADMIN') return true
    return workspaceAccess.canManageWorkspaceSettings.value
  })

  async function loadStaffRole() {
    const workspaceId = workspaceIdRef?.value
    if (!workspaceId) return
    await workspaceAccess.loadRoleForWorkspace(workspaceId)
  }

  return {
    canStaffManage,
    loadStaffRole
  }
}
